import { Select, Option } from "@jobber/components/Select";
import {FC} from "react";

type Account = {
    AccountID: string,
    Name: string,
    Code?: string,
    BankAccountNumber?: string,
    Type: string,
};

type AccountMappingDropdownProps = {
    loadingAccountOptions: Boolean,
    accountOptions: Array<Account>,
    setAccountCallback: Function,
};

const AccountMappingDropdown: FC<AccountMappingDropdownProps> = ({
  loadingAccountOptions,
  accountOptions,
  setAccountCallback,
}) => {
    return (
        <Select
            defaultValue={""}
            onChange={(accountID: string) => setAccountCallback(accountID)}
        >
            {
              accountOptions.length > 1 && <Option value={""} disabled>Select account</Option>
            }
            {
                accountOptions.length > 0
                    ? accountOptions.map((account: Account) =>
                        account.Type == "BANK"
                            ? <Option value={account.AccountID}>{account.Name} — {account.BankAccountNumber}</Option>
                            : <Option value={account.AccountID}>{account.Code} — {account.Name}</Option>

                    )
                    : loadingAccountOptions
                      ? <Option value={""} disabled>Fetching accounts...</Option>
                      : <Option value={""} disabled>No accounts found (see below for instructions)</Option>
            }
        </Select>
    );
}

export default AccountMappingDropdown;
